import React from 'react';
import { useTranslation } from 'react-i18next';
import AIAvatar from '../AIAvatar';

/**
 * Empty-state prompt chips shown before the user has any turns.
 * Adds a subtle staggered fade-up on the prompt list for a polished entrance.
 */
export default function SuggestedPrompts({ prompts, onSelect, title, subtitle, header }) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col h-full items-center justify-center text-center gap-4 pt-2 sm:pt-4">
      <AIAvatar size={64} label={t('aiAdvisor.brand')} animate />
      <div className="rp-advisor-msg-in" style={{ animationDelay: '80ms' }}>
        <h4 className="font-semibold text-slate-900 dark:text-slate-100 text-base">{title}</h4>
        <p className="text-sm text-slate-500 dark:text-slate-400 mt-1 max-w-xs">{subtitle}</p>
      </div>
      <div className="w-full mt-2">
        <p className="text-xs uppercase tracking-wider text-slate-400 dark:text-slate-500 mb-2 text-left">
          {header || t('aiAdvisor.suggested')}
        </p>
        <div className="flex flex-col gap-2">
          {prompts.map((prompt, idx) => (
            <button
              key={idx}
              data-testid={`ai-chat-suggested-prompt-${idx}`}
              onClick={() => onSelect(prompt, idx)}
              className="rp-advisor-stagger rp-advisor-focus text-left px-3.5 py-2.5 rounded-xl bg-slate-50 dark:bg-slate-800/50 border border-slate-200 dark:border-slate-700/70 hover:border-[#12355B]/60 dark:hover:border-[#45C04A]/60 hover:bg-white dark:hover:bg-slate-800 hover:-translate-y-0.5 hover:shadow-sm dark:hover:shadow-emerald-500/5 active:translate-y-0 text-sm text-slate-700 dark:text-slate-200 transition-[transform,border-color,background-color,box-shadow] duration-200 ease-out"
              style={{ animationDelay: `${120 + idx * 60}ms` }}
            >
              {prompt}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
